import { COLOR } from 'vars/index'

export const BorderColors = {
  TEXT_ICON_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
  ACCENT_SECONDARY: COLOR.ACCENT_SECONDARY,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
} as const
export type BorderColors = (typeof BorderColors)[keyof typeof BorderColors]

export const Background = {
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
  TEXT_ICON_CONSTANT_LIGHT: COLOR.TEXT_ICON_CONSTANT_LIGHT,
  ACCENT_PRIMARY_GRADIENT: COLOR.ACCENT_PRIMARY_GRADIENT,
  SURFACE_OPACITY_DARK_40: COLOR.SURFACE_OPACITY_DARK_40,
  DISABLED: COLOR.DISABLED,
} as const
export type Background = (typeof Background)[keyof typeof Background]

export const Color = {
  TEXT_IN_BUTTON_PRIMARY: COLOR.TEXT_ICON_CONSTANT_LIGHT,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
} as const
export type Color = (typeof Color)[keyof typeof Color]
